import BaseService from './base.service'
import moment from 'moment';

class BotsService extends BaseService {
  get entity () {
    return 'bot'
  }

  getBotWithProject(parameters = {}, commit) {
    const params = {
        ...parameters
    }
    const promises = [
        new Promise((resolved, rejected) => {
             return this.request({ auth: true }).get(`users/current/projects/${params.project_id}`)
                 .then(response => resolved(this.responseWrapper(response, response.data)))
                 .catch(error => {
                 let message = error.response.data ? error.response.data.error : error.response.statusText
                 rejected(this.errorWrapper(error, message))
                 })
         }),
         new Promise((resolved, rejected) => {    
            return this.request({auth: true}).get(`users/current/projects/${params.project_id}/bots/${params.id}`)
                 .then(response => resolved(this.responseWrapper(response, response.data)))
                 .catch(error => {
                 let message = '';//error.response.data ? error.response.data.error : error.response.statusText
                 rejected(this.errorWrapper(error, message))
                 })
         }),
      ];

      return Promise.all(promises)
        .then(data => {
          return data;
        });
  }

  updateProject(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${entity.data.id}`, {
        project_id: entity.data.id, 
        name: entity.data.name,
        starting_at: moment(entity.data.starting_at).format('YYYY-MM-DD'),
        ending_at: moment(entity.data.ending_at).format('YYYY-MM-DD')
      })
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
  
  getStepSettings() {

  }

  createBot(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post(`users/current/projects/${entity.params.project_id}/bots`, {
        project_id: entity.params.project_id,
        name: entity.params.name,
        goal: 0,
        graph: "linear"
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  deleteBot(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).delete(`users/current/projects/${entity.params.project_id}/bots/${entity.params.bot_id}`, {
        project_id: entity.params.project_id,
        bot_id: entity.params.bot_id
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  runBot(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post(`users/current/projects/${entity.project_id}/bots/${entity.bot_id}/run-now`, {
        project_id: entity.project_id,
        bot_id: entity.bot_id,
        tasks: entity.tasks,
        delay: entity.delay,
        repeats: entity.repeats
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  copyBot(entity) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post(`users/current/projects/${entity.project_id}/bots/${entity.bot_id}/copy`, {
        project_id: entity.project_id,
        bot_id: entity.bot_id,
        name: entity.name,
        to_project_id: entity.to_project_id
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
  
  getScenarioViewDetails(model, stepId) {
    
    //here i need to 
    /**
     * 1. find the step
     * 2. define it's type
     * 3. find some kind of a dictionary/config
     *  which specifies what to show to the user
     */
    var data = model.data.scenario.filter(element => element.id == stepId);
    
    var map = this.getParamsMap(data[0].name);
    if (map == null) return '';

    var paramsToShow = map.visual.params;
    var string = "";
    paramsToShow.forEach(element => {
      string += element.displayName + ":" + this.getParamValue(data[0].params, element.name) + "; ";
    });
    return string; 
  }

  getParamValue(paramsArray, paramName) {
    switch (paramName) {
      case 'uri' : {
        var value = paramsArray[paramName];
        
        if (Array.isArray(value)) {
          value = value[0];
          var uris = value.split(/\r?\n/);
          return uris[0];
          //if (value.indexOf(",") >= 0)
          //  return value.substring(0, value.indexOf(","));
        }
        
        break;
      }
    }
    return paramsArray[paramName];
  }

  getParamsMap(name) {
    switch(name) {
      case 'yandex_search': return {
        visual: {
          params:[{
            name:"uri",
            displayName:"url",
            type:"array"
          }],
          name:"Search in Yandex"
        }
      };

      case 'read_page': return {
          visual: {
            params:[{
              name:"min_time",
              displayName:"min",
              type:"integer"
            }, {
              name:"max_time",
              displayName: "max",
              type:"integer"
            }],
            name:"Read page"
        }
      };

      case 'set_cookie': return {
        visual: {
          params:[
            {
              name:"url",
              displayName: "url",
              type:"string"
            },
            {
              name:"domain",
              displayName: "domain",
              type:"string"
            },
            {
              name:"name",
              displayName: "name",
              type:"string"
            },
            {
              name:"value",
              displayName: "value",
              type:"string"
            },
            {
              name:"expires",
              displayName: "expires",
              type:"string"
            }
          ],
          name:"Set Cookie"
        }
      };

      case 'save_page_as_pdf': return {
        visual: {
          params:[],
          name: "Save page as PDF"
        }
      };

      case 'set_url_blocklist': return {
        visual: {
          params:[{
            name: "urls",
            displayName: "urls",
            type: "array"
          }],
          name: "Set URL Blocklist"
        }
      };

      case 'donor_acceptor': return {
        visual: {
          params:[
            {
              name: 'donor_uri',
              displayName: 'Donor Uri',
              type: 'array'
            },
            // Web view fails for unknown reasons when this is uncommented
            // {
            //   name: 'uri',
            //   displayName: 'Uri',
            //   type: 'array'
            // },
            {
              name: 'referer',
              displayName: 'Referer',
              type: 'array'
            },
            {
              name: 'mode',
              displayName: 'Mode',
              type: 'string'
            },
            {
              name: 'max_time',
              displayName: 'Max Time',
              type: 'number'
            },
            {
              name: 'min_time',
              displayName: 'Min Time',
              type: 'number'
            },
          ],
          name: "Donor Acceptor"
        }
      };

      case 'open': return {
        visual: {
          params:[{
            name:"uri",
            displayName:"url",
            type:"string"
          }],
          name:"Open page"
        }
      };

      case 'end_of_task': return {
        visual: {
          params:[{
            name:"finish_task_percentage",
            displayName:"Finish task",
            type:"integer"
          }],
          name:"End of task"
        }
      };

      case 'insert_multi': return {
        visual: {
          params:[{
            name:"selector",
            displayName:"CSS",
            type:"string"
          },
          {
            name:"xpath",
            displayName:"xPATH",
            type:"string"
          }
          ],
          name:"Insert multi"
        }
      };

      case 'yandex_image_search': return {
        visual: {
          params:[{
            name:"target_uri",
            displayName:"url",
            type:"array"
          }],
          name:"Search Images in Yandex"
        }
      };

      default: return null;
    }
  }

  getElementName(name) {
    switch(name) {
      case 'yandex_search': return 'Search in Yandex';
      case 'google_search': return 'Search in Google';
      case 'read_page': return 'Read page';
      case 'click': return 'Click';
      case 'wait': return 'Wait';
      case 'open': return 'Open';
      case 'hover': return 'Hover';
      case 'insert_multi': return 'Insert multi';
      case 'send_content': return 'SendContent';
      case 'element_presence': return 'Element Presence';
      case 'send_content': return 'Send Content';
      case 'end_of_task': return 'End of task';
      case 'success_state': return 'Success state';
      case 'set_cookie': return 'Set Cookie';
      case 'save_page_as_pdf': return 'Save page as PDF';
      case 'set_url_blocklist': return 'Set URL Blocklist';
      case 'donor_acceptor': return 'Donor Acceptor';
      case 'avito_registration': return 'Avito Registration';
      case 'yandex_image_search': return 'Yandex Image Search';
      default: return name;
    }
  }

  prepareCompleteBotModel() {

  }

  updateBot(model) {
    //collect all the data and push it to API
  
    return new Promise((resolve, reject) => {
      //take prepared model, redefine and repack some fields, update via action
     
      return this.request({ auth: true }).put(`users/current/projects/${model.project_id}/bots/${model.id}`, {
        name: model.name,
        project_id: model.project_id,
        scenario: (model.scenario === null) ? model.scenario : JSON.stringify(model.scenario),
        date_start: model.date_start,
        date_end: model.date_end,
        graph: model.graph,
        goal: parseInt(model.goal),
        growth_period: model.growth_period,
        start_count: model.start_count,
        bot_id: model.bot_id,
        tags: model.tags
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  setBotAdvanced(model) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).put(`users/current/projects/${model.project_id}/bots/${model.bot_id}/settings`, model)
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
}

export default new BotsService()
